export default function () {
  return {
    cacheaccess: [],
    cacheaccessCurrentPage: 1,
    cacheaccessLastPage: 1,
    cacheaccessPerPage: 0,
    cacheaccessTotal: 0,
    cacheaccessLoading: false,
    indexPage: null
  }
}
